export const TABS = [
    { id: 'background-url-tab', label: 'USE URL' },
    { id: 'background-file-tab', label: 'UPLOAD FILE' },
];
export const BACKGROUND_UPLOAD_FILE_ACCEPT = 'image/*';
//# sourceMappingURL=BackgroundImage.constants.js.map